// Shared helpers for converting between a plain "YYYY-MM-DD" calendar-date
// string (what the API stores and expects for check_in/check_out) and a JS
// Date object usable by react-datepicker.
//
// Why this exists: new Date("YYYY-MM-DD") parses as UTC midnight, and
// .toISOString() converts back to UTC. Either one, used on its own, silently
// shifts the displayed/submitted date by a day depending on which direction
// the viewer's local UTC offset runs (positive offsets like India roll it
// back on submit, negative offsets like the US roll it back on display).
// These helpers always go through the LOCAL calendar components directly,
// so the date shown/sent always matches the date the string represents,
// regardless of the viewer's timezone.

export const formatLocalDate = (date) => {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
};

export const parseLocalDate = (dateString) => {
  if (!dateString) return null;
  const [y, m, d] = dateString.split("-").map(Number);
  return new Date(y, m - 1, d);
};
